export const SortableColumns = [
	'countryName',
	'organizationName',
	'clientName',
	'clientTypeName',
	'jobRef',
	'jobName',
	'transactionRef',
	'transactionName',
	'customerName',
	'builderName',
	'estimateSentAt',
	'transactionRequirementsJoined',
	'salesPersonName',
	'estimateStatusName',
	'statusLastUpdatedAt',
	'reasonCode',
	'notes',
] as const;

export const VisibleColumns = [...SortableColumns] as const;
